import React from 'react';
import FilterStudent from './FilterStudent';
import { ToastContainer } from 'react-toastify';


export default class ExamRecognition extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    componentDidMount() {
        window.localStorage.removeItem('student');
        window.localStorage.removeItem('newStudyProgram');
    }

    render() {
        return (
            <div>
                <h1> Priznavanje ispita </h1>
                <FilterStudent />
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/StudentService/ExamRecognition/ExamRecognition.js